/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface PhoneDetails
 */
export interface PhoneDetails {
  /**
   * Country code for the phone number
   * @type {string | null}
   * @memberof PhoneDetails
   */
  country?: string | null;
  /**
   * Formatted phone number for display, deduced from number
   * @type {string | null}
   * @memberof PhoneDetails
   */
  display?: string | null;
  /**
   * Label for the phone number, default=mobile
   * @type {string | null}
   * @memberof PhoneDetails
   */
  label?: string | null;
  /**
   * phone number
   * @type {string}
   * @memberof PhoneDetails
   */
  number: string;
}

/**
 * Check if a given object implements the PhoneDetails interface.
 */
export function instanceOfPhoneDetails(value: object): value is PhoneDetails {
  if (!('number' in value) || value['number'] === undefined) return false;
  return true;
}

export function PhoneDetailsFromJSON(json: any): PhoneDetails {
  return PhoneDetailsFromJSONTyped(json, false);
}

export function PhoneDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PhoneDetails {
  if (json == null) {
    return json;
  }
  return {
    country: json['country'] == null ? undefined : json['country'],
    display: json['display'] == null ? undefined : json['display'],
    label: json['label'] == null ? undefined : json['label'],
    number: json['number'],
  };
}

export function PhoneDetailsToJSON(value?: PhoneDetails | null): any {
  if (value == null) {
    return value;
  }
  return {
    country: value['country'],
    display: value['display'],
    label: value['label'],
    number: value['number'],
  };
}
